module.exports = __webpack_public_path__ + "static/media/crxArtifact.2cbee374.png";